import { styled } from '@mui/material/styles'
import Avatar, { AvatarProps } from '@mui/material/Avatar'

export interface IAvatar extends AvatarProps {
  size?: 'xsmall' | 'small' | 'medium' | 'large'
}

export const ThemedAvatar = styled(Avatar)<IAvatar>(({ theme, size }) => ({
  width: '4.0rem',
  height: '4.0rem',
  backgroundColor: theme.palette.primary[500],
  fontWeight: 'bold',
  ...(size === 'xsmall' && {
    width: '2.5rem',
    height: '2.5rem',
    fontSize: '1.4rem',
  }),
  ...(size === 'small' && {
    width: '3.2rem',
    height: '3.2rem',
    fontSize: '1.8rem',
  }),
  ...(size === 'medium' && {
    width: '4.0rem',
    height: '4.0rem',
    fontSize: '1.8rem',
  }),
  ...(size === 'large' && {
    width: '8.6rem',
    height: '8.6rem',
    fontSize: '2.8rem',
  }),
}))
